/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PutApiV1SsoimageId200,
  PutApiV1SsoimageId400,
  PutApiV1SsoimageId401,
  PutApiV1SsoimageId500,
  PutApiV1SsoimageIdMutationRequest,
  PutApiV1SsoimageIdMutationResponse,
  PutApiV1SsoimageIdPathParams,
} from "../../types/SSOImageController/PutApiV1SsoimageId.ts";
import { ESSOCategorySchema } from "../ESSOCategorySchema.ts";
import { updateSSOImageLangViewModelSchema } from "../updateSSOImageLangViewModelSchema.ts";

export const putApiV1SsoimageIdPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<PutApiV1SsoimageIdPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const putApiV1SsoimageId200Schema =
  z.any() as unknown as ToZod<PutApiV1SsoimageId200>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const putApiV1SsoimageId400Schema =
  z.any() as unknown as ToZod<PutApiV1SsoimageId400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const putApiV1SsoimageId401Schema =
  z.any() as unknown as ToZod<PutApiV1SsoimageId401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const putApiV1SsoimageId500Schema =
  z.any() as unknown as ToZod<PutApiV1SsoimageId500>;

export const putApiV1SsoimageIdMutationRequestSchema = z.object({
  Title: z.string().max(250),
  CategoryId: z
    .lazy(() => ESSOCategorySchema)
    .describe(
      "1 = Agribusiness | 2 = DataTech | 3 = Finance | 4 = Education | 5 = MarketingAndSales | 6 = Business | 7 = Law | 8 = HumanResources | 9 = ProjectManagement | 10 = General | ",
    ),
  DateStart: z.optional(z.string().datetime()),
  DateEnd: z.optional(z.string().datetime()),
  Langs: z.array(z.lazy(() => updateSSOImageLangViewModelSchema)),
}) as unknown as ToZod<PutApiV1SsoimageIdMutationRequest>;

export const putApiV1SsoimageIdMutationResponseSchema = z.lazy(
  () => putApiV1SsoimageId200Schema,
) as unknown as ToZod<PutApiV1SsoimageIdMutationResponse>;
